// extracted by mini-css-extract-plugin
export default {"footerWrapper":"Footer_footerWrapper__jhKHO","footerTop":"Footer_footerTop__0AAXS","footerBottom":"Footer_footerBottom__Wkctg","footerRight":"Footer_footerRight__SVlXS"};